// extracted by mini-css-extract-plugin
export default {"social-media":"Mint-Media_social-media__p3acc","logo":"Mint-Media_logo__voDL+"};